import styled from "styled-components";

export const Title = styled.h2`
  font-size: 24px;
  line-height: 140%;
  font-weight: 700;
  color: #2A2637;
  margin-bottom: 40px;
  text-align: center;

  @media (min-width: 980px) {
    font-weight: 600;
    text-align: left;
    font-size: 36px;
    margin-bottom: 24px;
  }
`

export const Text = styled.div`
  font-size: 14px;
  line-height: 160%;
  color: #2A2637;

  @media (min-width: 980px) {
    font-size: 18px;
    line-height: 170%;
  }
`

export const Container = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  
  @media (min-width: 980px) {
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  
  @media (min-width: 1024px) {
    width: 940px;
  }
`

export const Left = styled.div`
  flex: 0 0 50%;
  order: 2;
  
  @media (min-width: 980px) {
    order: 1;
  }
`

export const Right = styled.div`
  flex: 0 0 50%;

  order: 1;

  @media (min-width: 980px) {
    order: 2;
  }
`

export const Icon = styled.div`
  padding: 0 0 55px 54px;
  position: relative;
  margin-bottom: 40px;
  
  &::before {
    content: '';
    position: absolute;
    display: block;
    left: 0;
    bottom: 0;
    width: 300px;
    height: 93px;
    background: #F18D64;
    opacity: 0.3;
    border-radius: 10px;
  }

  @media (min-width: 980px) {
    margin-bottom: 0;
    padding: 0 0 60px 90px;

    &::before {
      height: 252px;
      border-radius: 40px;
    }
  }
`

export const IconInfo = styled.div`
  background: #FFFFFF;
  border: 1px solid #C4BFD4;
  border-radius: 20px;
  position: relative;
  width: 100%;
  height: 93px;
  display: flex;
  align-items: center;
  justify-content: center;
  

  @media (min-width: 980px) {
    flex-direction: column;
    align-items: center;
    width: 300px;
    height: 232px;
  }
`

export const IconDayCount = styled.div`
  font-size: 55px;
  line-height: 100%;
  color: #797199;
  margin-right: 22px;

  @media (min-width: 980px) {
    font-size: 122px;
    margin-right: 0;
  }
`

export const IconText = styled.div`
  font-weight: 500;
  font-size: 22px;
  line-height: 100%;
  color: #A8A4B9;

  @media (min-width: 980px) {
    font-size: 33px;
  }
`

export const IconSvg = styled.div`
  margin-right: 22px;
  
  @media (min-width: 980px) {
    margin-right: 0;
    position: absolute;
    top: 55px;
    right: 50px;
  }
`